module.exports = "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAAAQAwCdASoZABkAPpFCnEolo6KhqAgAsBIJZQCuHBbbFWAA/vAqg1wtlmT/UTsRxl4nkmeJl0nIoDbZRwAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/rose.webp
// module id = s2Ci
// module chunks = 14